module.exports = __webpack_public_path__ + "static/media/topShirt.fef9c1f3.png";